module.exports = __webpack_public_path__ + "static/media/illustration8.09a5663e.png";